/* Pre-order on mobile — make the theme's own buttons defer to FoxKit.
   HEllO EDC, 9 Sep 2026. Product pages only.
   Ported from the India store, where the selectors were established by
   inspecting a live pre-order product in the browser.

   WHAT FOXKIT ALREADY DOES, CORRECTLY

   On a pre-order product FoxKit flags the page with `foxkit-preorder-show`
   on <body>, hides the theme's Add to Cart inside .product-form__buttons by
   adding its own `!foxkit-hidden` class, and puts its own button in its
   place with the dispatch note beneath:

     button.foxkit-preorder-submit.foxkit-button.foxkit-button--primary

   That is the whole desktop experience, and it is right. Nothing here
   changes it. That button is also the one this file delegates to — call it
   the canonical button.

   WHAT IT CANNOT KNOW ABOUT

   This theme adds two mobile-only add-to-cart controls that no app would
   expect, both hard-coding the words ADD TO CART:

     .dummy-buttons-wrapper   an in-page decoy above the description, whose
                              click is forwarded to the real submit button
     .sticky-atc-bar          the fixed bar at the bottom of the screen

   Neither is cosmetic.

   The DECOY forwards its click to [id^="ProductSubmitButton"] — the very
   button FoxKit has hidden. A hidden button still submits when clicked from
   script, so a shopper could tap ADD TO CART on a pre-order product and add
   it as an ordinary line, with none of what FoxKit attaches to mark it a
   pre-order. The order would look normal and be fulfilled as if the stock
   existed.

   The STICKY BAR is subtler. FoxKit does inject a copy of its own button
   there — but into .sticky-atc-bar__buynow-form, which is the old Buy Now
   form carrying <input name="return_to" value="/checkout">. Submitting it
   jumps straight to checkout, skipping the cart. Its twin in the product
   form is fine because that form has no return_to. So FoxKit's sticky copy
   is hidden in CSS and the theme's own sticky button is wired here instead.

   HOW

   Both buttons are relabelled from FoxKit's canonical button — never from a
   string written here, so the label always matches whatever is set in the
   FoxKit admin, in any language — and both have their clicks retargeted to
   it. What runs is FoxKit's control; these are only the surface.

   `wc-preorder-ready` on <body> tells the stylesheet the wiring is live. The
   sticky button is hidden until then, so a failure here shows no button
   rather than a wrong one.

   Does nothing at all unless FoxKit's flag is present. */

(function () {
  'use strict';

  if (window.__wcPreorder) return;
  window.__wcPreorder = true;

  var FLAG = 'foxkit-preorder-show';
  var READY = 'wc-preorder-ready';
  var PROXIES = '.dummy-add-to-cart, .sticky-atc-bar__btn--atc';
  var bound = false;

  /* The button in the product form, not the copy in the sticky bar: that copy
     sits in a form that redirects to checkout. */
  function canonical() {
    return document.querySelector('.product-form__buttons .foxkit-preorder-submit');
  }

  function isPreorder() {
    return !!(document.body &&
      document.body.classList.contains(FLAG) &&
      canonical());
  }

  function relabel() {
    var fox = canonical();
    if (!fox) return false;

    var label = (fox.textContent || '').trim();
    if (!label) return false;

    var done = false;
    document.querySelectorAll(PROXIES).forEach(function (btn) {
      /* Only write when it is wrong — the theme re-syncs the sticky button's
         text from the (hidden) Add to Cart on variant changes, so this runs
         again; without the guard the two would write over each other. */
      if (btn.textContent.trim() !== label) btn.textContent = label;
      done = true;
    });
    return done;
  }

  /* Capture phase, so this runs before the theme's own handlers and can stop
     the event reaching them. */
  function intercept(e) {
    if (!isPreorder()) return;

    var proxy = e.target.closest && e.target.closest(PROXIES);
    if (!proxy) return;

    var fox = canonical();
    if (!fox) return;   /* leave the theme's behaviour alone rather than break the page */

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    fox.click();
  }

  function apply() {
    if (!isPreorder()) return;

    var labelled = relabel();

    if (!bound) {
      document.addEventListener('click', intercept, true);
      bound = true;
    }

    /* Only now is the sticky button safe to show. */
    if (labelled && !document.body.classList.contains(READY)) {
      document.body.classList.add(READY);
    }
  }

  /* FoxKit adds its flag and its button after its own script loads, which is
     later than this file. Watch rather than assume. */
  function watch() {
    apply();

    try {
      new MutationObserver(apply).observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true
      });
    } catch (e) { /* no-op */ }

    /* Floor, in case the mutation that matters is missed. */
    var tries = 0;
    var poll = setInterval(function () {
      apply();
      if (++tries >= 20 || bound) clearInterval(poll);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
